import React, { Component } from "react";
import MaterialTable from "material-table";
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import Typography from '@material-ui/core/Typography';
import {
  editVehicleType,
  getVehicleTypeList,
} from '../../actions/vehicleTypes';
import SGMaterialTable from '../../components/UI/Table/SGMaterialTable';
class ListVechileTypes extends Component {
  componentDidMount(){
    this.props.getVehicleTypeList();
}
  render() {
    let { 
      vehicletypesListcols, 
      vehicletypesListrows,
      vehicleTypeListLoaderStatus
    } = this.props.vechiletypesState;
    return (
       <div 
        style = {{marginTop : '2rem', marginBottom : "2rem"}}
        className = "container"
      >
        <Paper>
            <div className = "pt-1 pl-3">
              <span className = "d-flex">
                <div className = "mr-auto" style = {{paddingTop : "0"}}>
                    <h4 style = {{marginTop : "1rem", textTransform : "uppercase"}}>Vehicle Type List</h4>
                </div>
                <div className = "d-flex flex-wrap align-content-center">
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick = {() => this.props.history.push("/sgadminportal/vehicletypes/newvehicletype")}
                        className = "mr-2"
                    >
                        <i className="material-icons" style = {{paddingRight : "0.5rem"}}>
                            add_circle_outline
                        </i>
                        Add Vehicle Type
                    </Button>
                </div>
              </span>
            </div>
            {
              vehicleTypeListLoaderStatus ? 
                <div style = {{height : "20rem"}} className = "d-flex justify-content-center align-items-center">
                    <CircularProgress color = "primary" />
                </div>:
                <MaterialTable
                  columns={vehicletypesListcols}
                  data={vehicletypesListrows}
                  title=""
                  editable={{
                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        if(newData.description !== ''){
                          resolve(this.props.editVehicleType(newData, vehicletypesListrows));
                        }else{
                          toast.error("Description field should not be blank", {containerId: 'toastMsg'});
                          reject();
                        }
                      }),
                  }}
                  options={{ actionsColumnIndex: -1}}
                />
              }
          </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    vechiletypesState: state.VehicleTypes
  };
};
const mapDispatchToProps = dispatch => {
  return{
    getVehicleTypeList : () => {
          return dispatch(getVehicleTypeList())
      },
    editVehicleType : (newData, vehicletypesListrows) => {
        return dispatch(editVehicleType(newData, vehicletypesListrows))
      }
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListVechileTypes);
